import { render } from "./Accordion.vue?vue&type=template&id=c160828a"
import script from "./Accordion.vue?vue&type=script&lang=js"
export * from "./Accordion.vue?vue&type=script&lang=js"

import "./Accordion.vue?vue&type=style&index=0&id=c160828a&lang=css"
script.render = render

export default script